import { render, staticRenderFns } from "./trill-question-item.vue?vue&type=template&id=7c9d71f9&scoped=true&"
import script from "./trill-question-item.vue?vue&type=script&lang=ts&"
export * from "./trill-question-item.vue?vue&type=script&lang=ts&"
import style0 from "./trill-question-item.vue?vue&type=style&index=0&id=7c9d71f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d71f9",
  null
  
)

export default component.exports